import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-screen min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Luxurious%20fashion%20retail%20display%20with%20carefully%20arranged%20sneakers%20hoodies%20and%20bags%20on%20minimal%20wooden%20shelves%2C%20warm%20natural%20sunlight%20streaming%20through%20large%20windows%2C%20cream%20walls%20and%20polished%20concrete%20floor%2C%20sophisticated%20boutique%20atmosphere%2C%20soft%20shadows%20and%20golden%20hour%20glow%2C%20editorial%20interior%20design%20photography&width=1920&height=1080&seq=hero-main-v2-x7k9&orientation=landscape"
          alt="CSSBuy Spreadsheet - Moda e estilo"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full flex flex-col items-center text-center px-4 md:px-6">
        <h1 className="mb-6">
          <span className="block font-sans text-6xl md:text-7xl lg:text-8xl font-bold text-white tracking-wide uppercase drop-shadow-lg">
            {t('hero.title_line1')}
          </span>
          <span className="block font-heading italic text-5xl md:text-7xl lg:text-8xl text-white mt-1 drop-shadow-md">
            {t('hero.title_line2')}
          </span>
        </h1>

        <p className="max-w-2xl text-base md:text-lg text-white/85 font-body font-light leading-relaxed mb-10 drop-shadow-sm">
          {t('hero.subtitle')}
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-4">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="flex items-center justify-center w-[200px] h-[52px] rounded-full bg-white text-foreground-900 font-semibold text-sm hover:bg-background-100 transition-all duration-200 shadow-lg whitespace-nowrap"
          >
            {t('hero.cta_spreadsheet')}
          </a>

          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="flex items-center justify-center gap-2 w-[200px] h-[52px] rounded-full bg-foreground-900 text-white font-semibold text-sm hover:bg-foreground-800 transition-all duration-200 shadow-lg whitespace-nowrap"
          >
            {t('hero.cta_buy')}
            <span className="w-[30px] h-[30px] rounded-full bg-primary-500 flex items-center justify-center">
              <i className="ri-arrow-right-line text-white text-xs"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}